/**
 * Subscription categories that pages and components open themselves, on
 * mount or lazily when first needed. Core setup didn't create them, so
 * signing in leaves them alone.
 *
 * On a full page load the page can mount before sign-in finishes, and
 * clearing them then left the page without data or live updates: the lineup
 * check-in said there was no lineup until you navigated away and back.
 * SubKrewe dues, products and the browsable SubKrewes were here too; they are
 * live sources now (utils/liveData.ts), which signing in doesn't clear.
 */
export const PAGE_OWNED_CATEGORIES: readonly string[] = [
  'lineup',
]

/**
 * Always kept: the auth listener, the member's own document, and what the
 * app-level initialize() registers once (its guard marker and the member
 * store watcher). Clearing the marker let every later useCoreSubscriptions()
 * call initialize and clear everything again.
 */
const ALWAYS_KEPT: readonly string[] = ['auth', 'member', 'app-init', 'store-subscription']

/**
 * The categories to clear when core subscriptions are reset. Signing in
 * keeps page-owned ones; signing out clears them too.
 */
export function categoriesToClear(categories: string[], { keepPageOwned }: { keepPageOwned: boolean }) {
  return categories.filter(category =>
    !ALWAYS_KEPT.includes(category)
    && !(keepPageOwned && PAGE_OWNED_CATEGORIES.includes(category)))
}
